import React, { useState, useEffect, useRef } from 'react';

import styles from './QuizParagraph.module.css';
import QuizParagraphSpan from "./QuizParagraphSpan/QuizParagraphSpan";
import { cleanTheScript } from '../../../helpers';

const QuizParagraph = props => {
	const mounted = useRef(false);
	const [timerId, setTimerId] = useState(0);
	const [currentDiffLevel, setCurrentDiffLevel] = useState(props.difficultyLevel);
	const block = props.block;
	const animationDurations = [[0.75, 1.0], [0.5, 0.75], [0.25, 0.5]];
	const normalAnimation = animationDurations[props.difficultyLevel-1][0];
	const longerAnimation = animationDurations[props.difficultyLevel-1][1];
	const paragraph = [];
	const script = cleanTheScript(block.script).split(' ');
	let animationDelayCounter = props.difficultyLevel <= 2 ? 0 : 1, wasLastWordLong = false;

	for (let i = 0; i < script.length; i++) {
		const duration = script[i].length <= 8 ? normalAnimation : longerAnimation;
		const noUselessSpaces = script[i] !== '' && script[i] !== ' ' && script[i] !== '  ' && script[i] !== '   ';
		if (noUselessSpaces) {
			if (wasLastWordLong) {
				animationDelayCounter += longerAnimation;
				wasLastWordLong = false;
			} else animationDelayCounter += normalAnimation;
			wasLastWordLong = script[i].length > 8;
			paragraph.push(
				<QuizParagraphSpan
					spanText={script[i]}
					key={i}
					textBGColor={props.textBGColor}
					delay={animationDelayCounter}
					duration={duration}
				/>
			);
		}
	}

	useEffect(() => {
		if (!mounted.current) {
			// createPara();
			const tempID = () => setTimeout(() => {   // so that the paragraph animation is let finished first
				// const animationDelay = props.quizMode ? 4250 : 1000;
				const animationDelay = 4250;
				props.startClosingAnimation();
				setTimeout(() => {
					props.doneWithThisParagraph();
					props.endClosingAnimation();
				}, animationDelay);
			}, (animationDelayCounter + 0.5) * 1000);  // giving a 0.5 second wait after paragraph has ended
			setTimerId(tempID());     // storing the timeout ID to this state so that clearTimeout can be used
			setCurrentDiffLevel(props.difficultyLevel)
			mounted.current = true;
		} else {
			if (props.endQuizNow) {   // triggered when 'End Quiz Now' button (from topic menu) is clicked
				clearTimeout(timerId);  // clearing the timeout so that there is no update after this component is unmounted
				props.doneWithThisParagraph();  // end this paragraph right away instead of timeout
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.endQuizNow])

	useEffect(() => {
		if (!mounted.current) {
			mounted.current = true;
		} else {
			if (currentDiffLevel !== props.difficultyLevel) {
				setCurrentDiffLevel(props.difficultyLevel)
				// console.log('diff level', currentDiffLevel)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.difficultyLevel])


	const quizParaStyle = {
		padding: block.script.length < 900 ? '10px 20px' : '0 10px',
		fontSize: block.script.length < 900 ? '20px' : '16px',
		lineHeight: block.script.length < 900 ? '15px' : '9px',
	}

	return (
		<div className={styles.QuizParaContainer}>
			<h4 className={styles.QuizHeading}>{props.themeName} question</h4>
			<div className={styles.QuizPara} style={quizParaStyle}>
				{paragraph}
			</div>
		</div>
	);
};

export default QuizParagraph;